import { render, staticRenderFns } from "./FrontendReact.vue?vue&type=template&id=6424f0d6&"
import script from "./FrontendReact.vue?vue&type=script&lang=js&"
export * from "./FrontendReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports